import { defined } from "common/Support";

type MessageTokenType = "url" | "text" | "newline" | "raw";

interface MessageToken {
    readonly type: MessageTokenType;
    readonly data: string;
}

const tokenizers = [
    {
        regex: /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#/%?=~_|!:,.;]*[-A-Z0-9+&@#/%=~_|])/i,
        type: "url" as MessageTokenType
    },
    {
        regex: /\n/,
        type: "newline" as MessageTokenType
    }
];

export function tokenizeMessage(message: string | MessageToken): readonly MessageToken[] {
    let token: MessageToken | undefined;
    if (typeof message === "string") {
        token = {
            type: "raw",
            data: message
        };
    } else {
        token = message;
    }

    if (token.type !== "raw") {
        return [token];
    }

    let type: MessageTokenType = "text";
    let match: RegExpMatchArray | null = null;
    for (const t of tokenizers) {
        match = token.data.match(t.regex);
        if (match !== null) {
            type = t.type;
            break;
        }
    }

    if (type === "text" || match === null) {
        return [
            {
                type,
                data: token.data
            }
        ];
    }

    const result: MessageToken[] = [];

    const index = defined(match.index);

    if (index !== 0) {
        result.push(
            ...tokenizeMessage({
                type: "raw",
                data: token.data.substring(0, index)
            })
        );
    }

    result.push({
        type,
        data: token.data.substring(index, index + match[0].length)
    });

    if (index + match[0].length < token.data.length) {
        result.push(
            ...tokenizeMessage({
                type: "raw",
                data: token.data.substring(index + match[0].length)
            })
        );
    }

    return result;
}
